export default __webpack_public_path__ + "static/media/logo.a39eac09.svg";